import { type VariantProps, cva } from 'class-variance-authority';
import * as React from 'react';

import { cn } from '@/lib/utils';

const badgeVariants = cva(
  'inline-flex items-center rounded-lg px-2 py-1 text-xs font-semibold ring-1 ring-inset',
  {
    variants: {
      variant: {
        default: 'bg-primary/10 text-primary ring-primary/20',
        success: 'bg-success/10 text-success ring-success/20',
        primary: 'bg-primary text-background ring-primary/20',
        warning: 'bg-warning/10 text-warning ring-warning/20',
        muted: 'bg-muted/10 text-muted-foreground ring-muted/20',
        secondary: 'bg-secondary/10 text-secondary ring-secondary/20',
        orange: 'bg-orange-400/10 text-orange-400 ring-orange-400/20',
        cyan: 'bg-cyan-400/10 text-cyan-400 ring-cyan-400/20',
        destructive: 'bg-destructive/40 text-foreground ring-destructive/20',
        outline: 'bg-background/10 text-foreground ring-border/20 border',
        ghost: 'bg-accent/50 text-foreground ring-halfmast-50/20 border',
        rose: 'bg-fuchsia-800 text-gray-50 ring-fuchsia-800/20',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}

export { Badge, badgeVariants };
